import { Box, CircularProgress, SxProps, Theme } from '@mui/material';

interface LoaderOverlayProps {
  isVisible: boolean;
  size?: number;
}

const overlayStyles: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(1px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1300,
  borderRadius: 1,
  animation: 'fadeIn 0.3s ease-in-out',
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
};

const spinnerStyles: SxProps<Theme> = {
  color: 'primary.main',
};

const LoaderOverlay: React.FC<LoaderOverlayProps> = ({
  isVisible,
  size = 48,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Box sx={overlayStyles}>
      <CircularProgress size={size} sx={spinnerStyles} />
    </Box>
  );
};

LoaderOverlay.displayName = 'LoaderOverlay';

export default LoaderOverlay;
